import NewMobileIcon from 'assets/svg/new_mobile-phone.svg'
import { THeaderType } from 'components/Header/Header'
import useTranslation from 'hooks/useTranslation'
import React from 'react'
import { TFunction } from 'src/providers/TranslateProvider/TranslateProvider'
import { BadgeType } from 'src/types'
import styled from 'styled-components'

interface BadgeDropdownProps {
  type: BadgeType | null | undefined
  theme?: THeaderType
}

const getTextByType = (type: BadgeType | null | undefined, t: TFunction) => {
  if (!type) {
    return null
  }

  return t(type)
}

const BadgeDropdown: React.FC<BadgeDropdownProps> = props => {
  const { type, theme } = props
  const { t } = useTranslation()

  if (type === BadgeType.Download) {
    return <img src={NewMobileIcon} alt='' />
  }

  return (
    <Badge $theme={theme} $type={type}>
      {getTextByType(type, t)}
    </Badge>
  )
}

export default BadgeDropdown

interface BadgeDropdownProps {
  active?: boolean
  text1?: string | null
  text2?: string | null
  type?: BadgeType | null
  theme?: THeaderType
}

const handleStyleBadgeType = (type?: BadgeType | null) => {
  switch (type) {
    case BadgeType.New:
      return `background: linear-gradient(180deg, rgba(21, 184, 57, 0.9) 0%, rgba(21, 184, 57, 0.54) 100%);
      box-shadow:  0px 4px 4px rgba(21, 184, 57, 0.25);`
    case BadgeType.Copy:
      return `background: #3071EE;
      `
    case BadgeType.Hot:
      return `background: linear-gradient(180deg, rgba(238, 94, 48, 0.9) 0%, rgba(238, 94, 48, 0.54) 100%);
      box-shadow:  0px 4px 4px rgba(238, 94, 48, 0.25);`
    case BadgeType.Popular:
      return `background: linear-gradient(180deg, rgba(48, 170, 238, 0.9) 0%, rgba(48, 170, 238, 0.54) 100%);
      box-shadow: 0px 4px 4px rgba(48, 170, 238, 0.25);`
    case BadgeType.Soon:
      return `background: linear-gradient(180deg, rgba(147, 151, 184, 0.9) 0%, rgba(147, 151, 184, 0.54) 100%);
        box-shadow:  0px 4px 4px rgba(147, 151, 184, 0.25);`
    case BadgeType.Bonus:
      return `background: linear-gradient(180deg, rgba(109, 48, 238, 0.9) 0%, rgba(109, 48, 238, 0.54) 100%);
        box-shadow:  0px 4px 4px rgba(109, 48, 238, 0.25);`
    case BadgeType.Promo:
      return `background: linear-gradient(180deg, rgba(255, 0, 0, 0.9) 0%, rgba(255, 0, 0, 0.54) 100%);
      box-shadow:  0px 4px 4px rgba(255, 0, 0, 0.25);`
    case BadgeType.BestOffer:
      return `background: linear-gradient(180deg, rgba(30, 180, 168, 0.9) 0%, rgba(59, 227, 211, 0.9) 100%);
      box-shadow:  0px 4px 4px rgba(30, 180, 168, 0.25);`
    case BadgeType.InDevelopment:
      return `background: linear-gradient(180deg, rgba(147, 151, 184, 0.9) 0%, rgba(147, 151, 184, 0.54) 100%);
      box-shadow:  0px 4px 4px rgba(147, 151, 184, 0.25);`
    case BadgeType.Tiket:
      return `background: rgba(48, 113, 238, 0.5);
      border: 1px solid #3071EE;
      backdrop-filter: blur(20px);`
    case BadgeType.Leaern:
      return `background: linear-gradient(180deg, rgba(30, 180, 168, 0.9) 0%, rgba(59, 227, 211, 0.9) 100%);
      box-shadow: 0px 4px 4px rgba(30, 180, 168, 0.25);`
    default:
      return ``
  }
}

const Badge = styled.span<{ $theme?: THeaderType; $type?: BadgeType | null }>`
  padding: 2px 0.5rem;
  text-transform: capitalize;
  ${({ $type }) => handleStyleBadgeType($type)};
  box-shadow: ${({ $theme }) => $theme === 'secondary' && 'none'};
  color: #f7fcff;
  border-radius: 24px;
  font-weight: 600;
  font-size: 0.625rem;
  line-height: 21px;
  white-space: nowrap;
`
